'use client'

import ImageWithFallback from '@/components/common/image-with-fallback'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { urlSafeProfilePath } from '@/helpers/url-safe-profile-path'
import { getUserProfilePictureUrl } from '@/helpers/user'
import { getDriverDisplayIdentifierDisplay } from '@/lib/driver-display-identifiers'
import Link from 'next/link'

export default function DriversSection({ eventDrivers, eventDriversLoading }) {
  return (
    <div className="screen-grid">
      <div className="grid-indent w-full">
        <h4 className="mt-6 text-h-5 font-semibold text-shades-0 desktop-xs:mt-10 desktop-xs:text-h-4">
          Drivers Attending
        </h4>

        <div className="divide hidden h-px bg-neutral-blue-700 desktop-xs:mt-6 desktop-xs:block" />

        {eventDriversLoading ? (
          <>
            <Skeleton className="hidden h-[38px] w-[80px] rounded-full desktop-xs:mt-6 desktop-xs:block" />
            <Skeleton className="mt-6 h-[400px] w-full" />
          </>
        ) : eventDrivers?.length > 0 ? (
          <>
            <div className="col-span-full hidden text-[12px] font-semibold leading-[14px] tracking-[4px] text-neutral-blue-500 desktop-xs:col-span-6 desktop-xs:mt-6 desktop-xs:grid desktop-xs:grid-cols-6 desktop-sm:col-span-7 desktop-sm:grid-cols-7">
              <p className="col-span-2">USER</p>
            </div>
            <div className="desktop-xs:block! col-span-full mt-2 desktop-xs:col-span-6 desktop-xs:mt-[23px] desktop-sm:col-span-7">
              {eventDrivers.map((member, index) => (
                <Link
                  className="group col-span-full -ml-5 flex items-center justify-between gap-3 rounded-md py-4 pl-5 pr-0 align-middle font-inter transition-all ease-in-out desktop-xs:grid desktop-xs:grid-cols-6 desktop-xs:pr-[14px] desktop-xs:hover:bg-neutral-blue-800 desktop-sm:grid-cols-7"
                  key={index}
                  href={urlSafeProfilePath({
                    ...member.user,
                    id: member.userId,
                    profileType: 'driver',
                  })}
                  target="_blank"
                >
                  <div className="col-span-4 flex items-center gap-3 align-middle">
                    <div className="relative aspect-square w-10 min-w-10 overflow-hidden rounded-full">
                      <ImageWithFallback
                        src={getUserProfilePictureUrl(member.user, {
                          profile: 'driver',
                        })}
                        alt="A users profile picture"
                        fill
                      />
                    </div>
                    <div className="flex flex-col">
                      <p className="truncate-1 break-all pb-[2px] text-p-1 font-normal desktop-xs:text-p-2">
                        {getDriverDisplayIdentifierDisplay(member, 'nickname')}
                      </p>
                    </div>
                  </div>

                  <div className="col-span-1 hidden desktop-sm:block"></div>
                  <div className="col-span-2 flex">
                    <Button
                      variant="outline"
                      asChild
                      className="bg-neutral-blue-900! hover:bg-white! hover:text-black! desktop-xs:group-hover:bg-white! desktop-xs:group-hover:text-black! ml-auto mr-0 py-2 font-inter text-p-1 transition-all ease-in-out desktop-xs:py-3"
                    >
                      <p>
                        View
                        <span className="hidden tablet:inline-block">
                          &nbsp;profile
                        </span>
                      </p>
                    </Button>
                  </div>
                </Link>
              ))}
            </div>
          </>
        ) : (
          <div className="mt-6 flex items-center rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 py-10">
            <h5 className="m-auto px-6 text-center">
              This event has no drivers
            </h5>
          </div>
        )}

        <div className="mt-[13px] hidden w-full items-center rounded-sm bg-primary-500 py-4 align-middle desktop-xs:flex">
          <p className="mx-auto w-fit text-p-2 font-semibold">Join Event</p>
        </div>

        <div className="divide mb-[22px] mt-4 h-px bg-neutral-blue-700 desktop-xs:mb-[22px] desktop-xs:mt-[33px]" />
      </div>
    </div>
  )
}
